<template>
	<component
		:is="shouldPopout ? 'a' : 'RouterLink'"
		:to="shouldPopout ? undefined : to"
		:href="shouldPopout ? '#' : undefined"
		v-bind="$attrs"
		@click="handleClick"
	>
		<slot />
	</component>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import store from '@/store'
import { openPopout } from '@/helpers/utils'

const props = defineProps({
	to: { type: [String, Object], required: true },
})

// Routes that should open in popout when in wrapper mode (full-page routes)
const POPOUT_ROUTES = [
	'tasks',
	'announcements',
	'mainsettings',
	'organization',
	'meeting',
	'groupoptions',
]

const router = useRouter()

const targetPath = computed(() => {
	if (typeof props.to === 'string') return props.to
	if (props.to.name) {
		const resolved = router.resolve(props.to)
		return resolved.path
	}
	return props.to.path || '/'
})

const routeName = computed(() => {
	if (typeof props.to === 'object' && props.to.name) return props.to.name
	const resolved = router.resolve(props.to)
	return resolved.name
})

const shouldPopout = computed(() => {
	return store.config.wrapper && POPOUT_ROUTES.includes(routeName.value)
})

function handleClick(e) {
	if (shouldPopout.value) {
		e.preventDefault()
		openPopout(targetPath.value)
	}
}
</script>
